import { useState } from 'react';

import HoverCard from 'src/componentes/hover-card';

// Abre no hover; o clique fixa o comentário aberto. Só um fica fixado por
// lista: passar o mouse em outra célula solta o que estava fixado.
const ComentarioCelula = ({ id, comentario, fixadoId, onFixar, children }) => {
  const [hover, setHover] = useState(false);
  const fixado = !!comentario && fixadoId === id;

  const celula = (
    <div
      className={comentario ? 'tw:cursor-pointer' : undefined}
      onClick={() => comentario && onFixar(fixado ? null : id)}
    >
      <span className={fixado ? 'tw:font-bold' : undefined}>{children}</span>
    </div>
  );

  if (!comentario) return celula;

  return (
    <HoverCard
      placement="left"
      open={hover || fixado}
      onOpenChange={(open) => {
        setHover(open);
        if (open && fixadoId && !fixado) onFixar(null);
      }}
      className="tw:max-h-150 tw:max-w-150 tw:overflow-auto"
      content={<span>{comentario}</span>}
    >
      {celula}
    </HoverCard>
  );
};

export default ComentarioCelula;
